<template>
  <div class="header">
    <button @click="backButtonClicked" class="button-close"></button>
    <div class="current-datetime">
      現在時刻
      <span>
        {{ currentTime }}
      </span>
    </div>
    <PSFaceTicketNameDisp :ticketName="ticketName" />
  </div>
</template>

<script>
export default {
  name: "TheMyticketHeader",
  props: {
    ticketName: {
      type: String,
      required: false,
    },
    clickBackButtonEvent: {
      type: Function,
      required: false,
      default: null,
    },
  },
  mounted() {
    setInterval(() => this.updateCurrentTime(), 1 * 1000);
  },
  data() {
    return {
      // 現在時刻
      currentTime: this.$moment().format("YYYY.MM.DD HH:mm:ss"),
    };
  },
  methods: {
    backButtonClicked() {
      if (this.clickBackButtonEvent) {
        this.clickBackButtonEvent();
      } else {
        this.backToPreviousPage();
      }
    },
    updateCurrentTime() {
      this.currentTime = this.$moment().format("YYYY.MM.DD HH:mm:ss");
    },
  },
};
</script>

<style lang="scss" scoped>
.header {
  position: relative;
  height: 138px;
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAIAAAADCAYAAAC56t6BAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyNpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDYuMC1jMDAyIDc5LjE2NDQ2MCwgMjAyMC8wNS8xMi0xNjowNDoxNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIDIwMjAgTWFjaW50b3NoIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOkVFMzBEMDdEQ0FGQjExRUFCMDFFQ0E1MTgyN0E4MDFBIiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOkVFMzBEMDdFQ0FGQjExRUFCMDFFQ0E1MTgyN0E4MDFBIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6RUUzMEQwN0JDQUZCMTFFQUIwMUVDQTUxODI3QTgwMUEiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6RUUzMEQwN0NDQUZCMTFFQUIwMUVDQTUxODI3QTgwMUEiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz5w5jeNAAAAHklEQVR42mL8f4bhBwMQsDA8ZmCHMP4x/AQxAAIMAF8dBa6sXS5bAAAAAElFTkSuQmCC);
  background-size: 2px 3px;
}

.header button.button-close {
  position: absolute;
  top: 50px;
  right: 15px;
  width: 26px;
  height: 26px;
  border: none;
  border-radius: 50%;
  background-color: transparent;
  background-image: url("~@/assets/img/icon/svg/button-close.svg");
  background-size: 26px 26px;
  box-shadow: var(--defaultBoxShadow);
  z-index: 1;
}

.header .current-datetime {
  position: absolute;
  top: 55px;
  margin-left: 15px;
  font-size: 13px;
}

.header .current-datetime span {
  font-weight: bold;
}
</style>
